import React from 'react';
import { Container, Box, Icon, Body } from '@hover/blueprint';
import { INSURANCE_BETTER_WAY_TO_BUILD_CAROUSEL_DATA } from '../../../constants';

const InvitedByInsuranceBetterWayMobile: React.FC = () => (
  <Container
    d={{ base: 'flex', desktop: 'none' }}
    px={500}
    flexDir="column"
    centerContent
  >
    {INSURANCE_BETTER_WAY_TO_BUILD_CAROUSEL_DATA.map(item => (
      <Box
        w="100%"
        flexDir="column"
        alignItems="center"
        key={item.index}
        mb={item.index === 1 ? 0 : 900}
        pb={item.index === 1 ? 0 : 200}
      >
        <Container centerContent mb={800} maxW="md">
          {item.img}
        </Container>
        <Box
          w="56px"
          h="56px"
          borderRadius="50%"
          bg="green.500"
          alignItems="center"
          justifyContent="center"
          mb={500}
        >
          <Icon icon={item.icon} size="large" color="neutral.0" />
        </Box>
        <Body size={600} isSemiBold textAlign="center">
          {item.body}
        </Body>
      </Box>
    ))}
  </Container>
);

export default InvitedByInsuranceBetterWayMobile;
